import { ContrastColorValues } from './types';

export const ACCESSIBILITY_MIN_CONTRAST = 3;

export const DECORATIVE_ELEMENT_MIN_CONTRAST = 1.1;

export const DEFAULT_COLOR_CONTRAST_VALUES: ContrastColorValues = {
  lowContrastReturn: '#000000',
  highContrastReturn: '#FFFFFF',
  contrastRatio:
    ACCESSIBILITY_MIN_CONTRAST /* recommended min accessible contrast ratio */,
  contrastingColor: '#FFFFFF',
};
